import { throttle } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { Slider as SliderUI } from '../../../Slider/Slider';
import { Wrapper } from './Slider.style';
import { roundFixed } from './Slider.utils';

export type SliderProps = {
  param: Json;
  onChange: (value: number) => void;
  onSet: (value: number) => void;
};

export function Slider(props: SliderProps) {
  const { param } = props;
  const { value, config } = param;
  const { min = 0, max = 1, step = 0.01 } = config || {};

  const [val, setVal] = useState(value);

  const throttledOnChange = useCallback(
    throttle((value: number) => {
      props.onChange(value);
    }, 50),
    []
  );

  function onChange(value: number) {
    value = roundFixed(value, 2);
    setVal(value);
    throttledOnChange(value);
  }

  function onSet(value: number) {
    roundFixed(value, 2);
    props.onSet(value);
  }

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <Wrapper className='Slider-wrapper' data-testid='Slider-wrapper'>
      <SliderUI
        color='blue'
        value={val}
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        onChangeEnd={onSet}
        marks={[{ value: 0 }, { value: 0.25 }, { value: 0.5 }, { value: 0.75 }, { value: 1 }]}
      />
    </Wrapper>
  );
}

export default Slider;
